import React from "react";

const COA = () => {
  const onButtonClick = () => {
    // using Java Script method to get PDF file
    fetch("../../Files/Computer Org & Arch.pdf").then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "Computer Organization and Architecture.pdf";
        alink.click();
      });
    });
  };

  return (
    <div className="py-12 bg-gray-50">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-screen-xl lg:px-8">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          <div className="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left">
            <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">
              COA
            </h2>
            <h1 className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
              Computer Organization and Architecture
            </h1>
            <p className="mt-4 text-lg leading-6 text-gray-500">
              This resource covers the fundamentals of Computer Organization and
              Architecture, including basic structure of computers, CPU, memory,
              I/O, and more.
            </p>
            <div className="mt-6">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.javatpoint.com/computer-organization-and-architecture-tutorial"
                className="inline-flex bg-indigo-500 border border-transparent rounded-md font-semibold text-white hover:bg-indigo-600 active:bg-indigo-700 px-4 py-2 text-base shadow-md
            transition duration-150 ease-in-out"
              >
                Learn more
              </a>
            </div>
          </div>
          <div className="mt-12 lg:mt-0 lg:col-span-6">
            <div className="max-w-md mx-auto">
              <img
                className="object-cover object-center rounded-lg shadow-lg"
                // src="https://pixabay.com/illustrations/cyber-security-technology-network-3374252/"
                src={require("../../images/Computer-Organization-And-Architecture.jpg")}
                alt="COA"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <hr className="mt-8" />
      </div>
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <h1 className="text-2xl font-semibold text-gray-900">
            COA Resources
          </h1>
          <div className="mt-6 sm:mt-8">
            <ul className="divide-y divide-gray-200">
              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Digital Fundamentals
                    </h3>
                    <p className="text-base leading-6 text-gray-500">
                      It is necessary to understand the fundamentals of digital
                      electronics before learning COA. This resource covers the
                      fundamentals of digital electronics, including number
                      systems, logic gates, combinational circuits, sequential
                      circuits, and more.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.javatpoint.com/digital-electronics"
                        className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                      >
                        Learn more &rarr;
                      </a>
                    </p>
                  </div>
                </div>
              </li>
              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Register Transfer and Microoperations
                    </h3>
                    <p className="text-base leading-6 text-gray-500">
                      This resource covers the fundamentals of register transfer
                      and microoperations. It also covers the different types of
                      microoperations and the different types of shift
                      registers.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://unacademy.com/content/nta-ugc/study-material/computer-science/register-transfer-language-and-micro-operations/#:~:text=Register%20transfer%20language%20is%20a,referred%20to%20as%20register%20transfer."
                        className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                      >
                        Learn more &rarr;
                      </a>
                    </p>
                  </div>
                </div>
              </li>
              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Basic Computer Organization and Design
                    </h3>
                    <p className="text-base leading-6 text-gray-500">
                      This resource covers the fundamentals of basic computer
                      organization and design, including instruction cycle,
                      instruction pipelining, hardwired and microprogrammed
                      control units, and more.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.javatpoint.com/computer-instructions"
                        className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                      >
                        Learn more &rarr;
                      </a>
                    </p>
                  </div>
                </div>
              </li>
              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Microprogrammed Control Unit
                    </h3>
                    <p className="text-base leading-6 text-gray-500">
                      This resource covers the fundamentals of microprogrammed
                      control unit, including microinstruction sequencing,
                      microinstruction execution, and more.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://byjus.com/gate/microprogrammed-control-unit-notes/#:~:text=A%20microprogrammed%20control%20unit%20is,the%20instructions%20to%20be%20executed."
                        className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                      >
                        Learn more &rarr;
                      </a>
                    </p>
                  </div>
                </div>
              </li>

              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Computer Arithmetic
                    </h3>
                    <p className="text-base leading-6 text-gray-500">
                      This resource covers the fundamentals of computer
                      arithmetic, including addition, subtraction,
                      multiplication, division, floating-point arithmetic, and
                      more.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.cise.ufl.edu/~mssz/CompOrg/CDA-arith.html"
                        className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                      >
                        Learn more &rarr;
                      </a>
                    </p>
                  </div>
                </div>
              </li>

              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Input and Output Organization
                    </h3>
                    <p className="text-base leading-6 text-gray-500">
                      This resource covers the fundamentals of input and output
                      organization, including input and output devices,
                      input-output interface, asynchronous data transfer, and
                      more.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.studytonight.com/computer-architecture/input-output-organisation#:~:text=Input%2DOutput%20Interface&text=In%20computer%20system%2C%20there%20are,between%20processor%20bus%20and%20peripherals."
                        className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                      >
                        Learn more &rarr;
                      </a>
                    </p>
                  </div>
                </div>
              </li>

              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Memory Organization
                    </h3>
                    <p className="text-base leading-6 text-gray-500">
                      This resource covers the fundamentals of memory and its
                      organization, including memory hierarchy, cache memory,
                      virtual memory, and more.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.studyadda.com/notes/ssc/computers-science/computer-memories/memory-organisation/15467"
                        className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                      >
                        Learn more &rarr;
                      </a>
                    </p>
                  </div>
                </div>
              </li>

              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Multiple Process Organization
                    </h3>
                    <p className="text-base leading-6 text-gray-500">
                      This resource covers the fundamentals of multiple process
                      and its organization, including multiple process
                      organization, multiple process synchronization, and more.
                    </p>
                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.geeksforgeeks.org/introduction-of-multiprocessor-and-multicomputer/"
                        className="font-medium text-indigo-600 hover:text-indigo-500 transition duration-150 ease-in-out"
                      >
                        Learn more &rarr;
                      </a>
                    </p>
                  </div>
                </div>
              </li>

              <li className="py-4">
                <div className="flex space-x-3">
                  <div className="flex-1 space-y-1">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                      Previous Year Question Paper:
                    </h3>

                    <p className="mt-1 text-sm leading-5 text-gray-500">
                      <button
                        onClick={onButtonClick}
                        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2"
                      >
                        Download
                      </button>
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default COA;
